var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33 6.69v12.7l9.97-6.35-9.97-6.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13A13 13 0 1113 0a13 13 0 0113 13zM13 2.18a10.89 10.89 0 1010.84 10.88A10.89 10.89 0 0013 2.18z"
  })));
}
SvgPlay.displayName = 'Play';
export default SvgPlay;